export enum LcSummaryTab {
  ProductInformation = "0",
  CAD = "1",
}
